import PageLoader from 'components/Shared/PageLoader';
import Toast from 'components/Shared/Toast';
import React, { useEffect } from 'react';
import { withRouter } from 'react-router';
import userService from 'services/user';

interface IProps {
  match: any;
  history: any;
}

const LoginAsBuyer = ({ match, history }: IProps) => {
  useEffect(() => {
    const hash = match.params.hash;
    userService.loginByEventHash({ hash }).subscribe(
      data => history.push(data.redirect),
      err => {
        console.log(err);
        if (err.message === 'Request failed with status code 403') {
          Toast.error(
            'Permissão Negada. O administrador desta conta não lhe concedeu privilégio para acessar este recurso',
            6000,
          );
        }
      },
    );
  });

  return <PageLoader />;
};

export default withRouter(LoginAsBuyer);
